/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AwardDto from './AwardDto';
import PaginationModel from './PaginationModel';

/**
 * The SearchingQueryResponseModelAwardDto model module.
 * @module model/SearchingQueryResponseModelAwardDto
 * @version v1.0.0
 */
class SearchingQueryResponseModelAwardDto {
    /**
     * Constructs a new <code>SearchingQueryResponseModelAwardDto</code>.
     * @alias module:model/SearchingQueryResponseModelAwardDto
     */
    constructor() { 
        
        SearchingQueryResponseModelAwardDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SearchingQueryResponseModelAwardDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SearchingQueryResponseModelAwardDto} obj Optional instance to populate.
     * @return {module:model/SearchingQueryResponseModelAwardDto} The populated <code>SearchingQueryResponseModelAwardDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchingQueryResponseModelAwardDto();

            if (data.hasOwnProperty('pagination')) {
                obj['pagination'] = PaginationModel.constructFromObject(data['pagination']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], [AwardDto]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/PaginationModel} pagination
 */
SearchingQueryResponseModelAwardDto.prototype['pagination'] = undefined;

/**
 * search result list
 * @member {Array.<module:model/AwardDto>} result
 */
SearchingQueryResponseModelAwardDto.prototype['result'] = undefined;






export default SearchingQueryResponseModelAwardDto;

